const calendarStyledCompCalendar = {
  culture: 'pt-br'
};

export default calendarStyledCompCalendar